import { render } from "./CampaignsDetailPerformancePerCategory.vue?vue&type=template&id=8363de84&scoped=true"
import script from "./CampaignsDetailPerformancePerCategory.vue?vue&type=script&lang=js"
export * from "./CampaignsDetailPerformancePerCategory.vue?vue&type=script&lang=js"

import "./CampaignsDetailPerformancePerCategory.vue?vue&type=style&index=0&id=8363de84&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8363de84"]])

export default __exports__